import { NotificationAlertOverride } from ".";
import { verificationService } from "../../../../../shared/services/verificaiton";

export const BankingFailed: NotificationAlertOverride = (_, history) => ({
  action: {
    text: "Complete verification",
    onClick: async () => {
      await verificationService.completeBankingVerification(history);
    }
  }
});
